const Table = ({ children, className }) => {
    return (
        <div className={`max-w-full overflow-x-auto ${className}`}>
            <table className="w-full text-center table-auto">{children}</table>
        </div>
    )
}
Table.TR = ({ children, className, ...props }) => {
    return (
        <tr {...props} className={`hover:bg-gray dark:hover:bg-graydark ${className}`}>
            {children}
        </tr>
    )
}
Table.TH = ({ print_format = false, children, className, ...props }) => {
    return (
        <th
            {...props}
            className={`border py-1 px-2 text-center ${print_format ? 'font-bold border-stroke dark:border-strokedark text-black dark:text-white' : 'font-medium border-white dark:border-boxdark text-white bg-primary dark:bg-secondary'} ${className}`}
        >
            {children}
        </th>
    )
}
Table.TD = ({ children, className, ...props }) => {
    return (
        <td
            {...props}
            className={`border border-stroke dark:border-strokedark items-center text-black dark:text-white py-1 px-2 ${className}`}
        >
            {children}
        </td>
    )
}
export default Table
